import React from "react";
import {Box, Columns, Heading, Table} from "react-bulma-components";
import {useContactsData} from "../../hooks/useContactsData";
import {getContactsData} from "../../state/selectors";
import LoadingSpinner from "../Utils/Spinner";
import {useSelector} from "react-redux";



export default function ContactSection(props){
    const dataLoaded = useContactsData({partial_view: "YES"});
    const data = useSelector(getContactsData);

    if(!dataLoaded){
        return (
            <LoadingSpinner/>
        )
    }

    return (
        <Box>
            <Heading size={5}>Incomplete Contacts</Heading>
            <Columns>

                <Columns.Column>
                    <Table>
                        <thead>
                            <tr>
                                <th>Display Name</th>
                                <th>Contact Type</th>
                            </tr>
                        </thead>
                        <tbody>
                        {data.results.map(contact => (
                            <tr>
                                <td>{contact.display_name}</td>
                                <td>{contact.contact_type === "CC" ? "Customer" : "Supplier"}</td>
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                </Columns.Column>
            </Columns>
        </Box>
    )


}